module.exports = __webpack_public_path__ + "static/media/tech rider example 1.00551ae2.docx";